import { render } from "./TgSubscribeVector.vue?vue&type=template&id=31c286b4"
import script from "./TgSubscribeVector.vue?vue&type=script&lang=js"
export * from "./TgSubscribeVector.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__